import React, { memo } from 'react'
import { Skeleton } from 'transfix-ui/core'
import Typography, { ITypographyProps } from 'transfix-ui/core/Typography'
import { Maybe } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'

interface ICarrierOptionRateCardRowProps {
  title: string
  value: Maybe<string>
  className?: string
  color?: ITypographyProps['color']
  dataTest?: string
  loading?: boolean
  typographyVariant?: ITypographyProps['variant']
  valueColor?: ITypographyProps['color']
}

const CarrierOptionRateCardRow = memo<ICarrierOptionRateCardRowProps>(
  ({
    className = '',
    color = 'textPrimary',
    dataTest,
    loading = false,
    title,
    typographyVariant = 'body2',
    value,
    valueColor: valueColorProp,
  }) => {
    const valueColor = valueColorProp || color
    return (
      <div className={`flex ${className}`} data-test={dataTest}>
        <Typography variant={typographyVariant} color={color} component='div'>
          {title}
        </Typography>
        {loading ? (
          <Skeleton variant='text' width={70} />
        ) : (
          <Typography variant={typographyVariant} color={valueColor} component='div'>
            {value || DISPLAY.empty}
          </Typography>
        )}
      </div>
    )
  }
)

export default CarrierOptionRateCardRow
